 

import { isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule, FormGroupDirective} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { FuseCardComponent } from '@fuse/components/card';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
 
import {MatSelectModule} from '@angular/material/select';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { Router } from '@angular/router';
import { IFeasibility, IPackages } from 'app/core/shared-services/interfaces.types';
import { GoogleMapsModule } from '@angular/google-maps';
import { SwiperPackagesComponent } from '../swiper-packages/swiper-packages.component';
import Swal from 'sweetalert2';

@Component({
  standalone: true,
  selector: 'app-relocate-service',
  templateUrl: './relocate-service.component.html',
  styleUrls: ['./relocate-service.component.scss'],
  imports: [NgFor, MatSelectModule, MatDialogModule, FuseCardComponent, MatProgressSpinnerModule, MatButtonModule, NgIf, FormsModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, GoogleMapsModule, SwiperPackagesComponent]
})

export class RelocateServiceComponent {
  // ## VARS ##
  public location: HTMLElement;
  @ViewChild('searchTextRef') searchInputRef: ElementRef;
  public selectedPlace: boolean;
  public packageDetails: any;
  public availablePackages: [];
  public loading: boolean;
  public cancellationReasonsList: any;
  public relocateServiceForm: UntypedFormGroup;
  public mapCenter: {lat: number, lng: number };
  public packagesResult: any;
  public locationValue: UntypedFormGroup;
  public place: any;
  
 
  private feasibilityResult: IFeasibility;
  private feasibility: any;
  private LeadEntityID: number;
  private packages: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any
  ){}
  // ## DEPENDENCIES ##
  private _sharedMethods = inject(SharedMethodsModule);
  private _webStorage = inject(WebStorage);
  private router = inject(Router);
  private _matDialog = inject(MatDialogRef<RelocateServiceComponent>);
  private formBuilder = inject(UntypedFormBuilder);
  private _sharedServices = inject(SharedServiceService);
  private changeDetector = inject(ChangeDetectorRef);
 

   ngOnInit(){
    this.loading = false;
    this.selectedPlace = false;
    this.relocateServiceForm = this.formBuilder.group({
      locationValue: [''],
    });
     this.packageDetails = this._sharedServices.activeCustomerServices;
     this.getCancelationReasonOData();
   }
 
   public closeDialog(){
     this._matDialog.close();
   }


   public proceed(){
    if(this.LeadEntityID && this.packagesResult?.length >= 1){
      // this.selectedPlace = true;
    }else{
      Swal.fire({
        title: 'Failed to get location!',
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'OKAY',
        showConfirmButton: true,
        customClass: {
          htmlContainer: 'text-xl',
          confirmButton: 'custom-button text-lg',
        }
      });
    }
 
   }


 
  public async getPlaceAutocomplete() {
    this.loading = true;
    
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem("LeadEntityId");
      this._webStorage.StoredLead.next(0);
      const input = document.getElementById('searchTextField') as HTMLInputElement;
      const options = {
        componentRestrictions: { country: 'ZA' },
        types: ['geocode', 'establishment',],
        fields: ['formatted_address', 'address_components', 'geometry']
      }
      options.componentRestrictions = { country: 'za' }
      const autocomplete = new window.google.maps.places.Autocomplete(input, options);
      
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        this.selectedPlace = true;
        this.changeDetector.detectChanges();
        this.place = autocomplete.getPlace();
        this.invokeEvent(this.place);
      });
    }
  }



  
  public invokeEvent(place: any) {
    
    if (isPlatformBrowser(this.platformId)) {
      const address = place.formatted_address
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({
        address: address
      }).then(async (response) => {
        const coords = {
          latitude: response.results[0].geometry.location.lat(),
          longitude: response.results[0].geometry.location.lng()
        }
        // sets the centre of map and marker when typing in address
        this.mapCenter = {
          lat: response.results[0].geometry.location.lat(),
          lng: response.results[0].geometry.location.lng()
        }
  
        this.feasibility = await this._sharedMethods.geoCode(null, coords);
  
        if (this.feasibility.success) {
          this.feasibilityResult = this.feasibility.result;
          this.LeadEntityID = this.feasibilityResult.LeadEntityID;
          this._webStorage.StoredLead.next(this.LeadEntityID);
          // sets the required info and checks interface
          if (this.feasibilityResult.Feasibility == 'Yes' || this.feasibilityResult.Feasibility == 'Maybe') {
            // feasibility is 'Yes' and values are set, now retrieve packages
            this.packages = await this._sharedMethods.getAvailablePackages(this.LeadEntityID);
            if (this.packages.success) {
              this.packagesResult = this.packages.result;
              // this._webStorage.StorePackages(this.packagesResult);
              
            }
          } else {
            
          }
        }
  
        this._webStorage.SetCustomerCoordinates(coords);
        this._webStorage.SetCustomerGoogleAddress(place);
      })
    }
  }

 
   private getCancelationReasonOData(){
     this._sharedMethods.getCancelationReasonOData().then((res) => {
      this.cancellationReasonsList = res?.result?.value;       
     }).finally(()=>{
      this.loading = false;
     });
   }

 }

 
